import { render } from "./ResetPin.vue?vue&type=template&id=a7d3c370&scoped=true&ts=true"
import script from "./ResetPin.vue?vue&type=script&lang=ts"
export * from "./ResetPin.vue?vue&type=script&lang=ts"

import "./ResetPin.vue?vue&type=style&index=0&id=a7d3c370&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d3c370"]])

export default __exports__